const state = {
    search: "",
}

// getters
const getters = {
    search(state) {
        // console.log("getters state", state.search)
        return state.search
    },
}

// actions
const actions = {
    pesquisar({ commit }, payload) {
        commit('setSearch', payload)
    }
}

// mutations
const mutations = {
    setSearch(state, payload) {
        state.search = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
